@use '@/styles/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  min-height: 112px;
  padding: var(--space-6);
  text-align: center;
  background: $color-accent1-50;
  border: 1.5px dashed color-mix(in srgb, $color-accent1-700 45%, transparent);
  border-radius: var(--radius-xl);
  cursor: pointer;
  transition:
    border-color 0.12s ease,
    background 0.12s ease;

  &:hover {
    border-color: color-mix(in srgb, $color-accent1-700 70%, transparent);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.dragOver {
  background: $color-accent1-100;
  border-color: $color-accent1-700;
}

.invalid {
  border-color: var(--status-danger);

  &:hover {
    border-color: var(--status-danger);
  }
}

.disabled {
  cursor: default;
  background: var(--surface-muted);
  border-color: var(--border-default);

  .cloud {
    color: var(--text-disabled);
  }
}

.cloud {
  color: $color-brand-700;
}

.help {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
}

.input {
  display: none;
}

.thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.thumb {
  position: relative;
  width: 76px;
  height: 76px;
  border-radius: var(--radius-lg);
  background: var(--surface-muted);
}

.thumbImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-subtle);
}

.uploading {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(20, 47, 12, 0.45);
  border-radius: var(--radius-lg);
  color: #fff;
}

.spinner {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.remove {
  position: absolute;
  top: -7px;
  right: -7px;
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #fff;
  background: $color-brand-950;
  border: 2px solid var(--surface-card);
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition: background 0.12s ease;

  &:hover {
    background: #000;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}
